import { stripHtml } from '@src/utility/sanitizeHtml';

/**
 * Converts HTML content to plain text, preserving line breaks.
 * Converts `<br>` and `</p>` tags to newlines before stripping
 * all remaining HTML.
 */
export function htmlToPlainText(html: string): string {
  const withNewlines = html
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/p>/gi, '\n');
  return stripHtml(withNewlines).trim();
}
